import { useMutation, useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, fetchConfig, getApiRouteOrMock } from './api.utils';

export default function useTabs(currentPublisherId?: string) {
  const axios = useAxios();

  const getTabs = useQuery({
    ...fetchConfig.list,
    queryKey: [EQueryKeys.TABS],
    queryFn: async () => {
      try {
        return await axios.get(getApiRouteOrMock(EApiRoutes.TABS));
      } catch (error) {
        console.log('error fetching tabs:', error);
        return [];
      }
    },
    enabled: !!currentPublisherId
  });

  const upsertTabs = useMutation(async (data: any) => {
    return await axios.post(getApiRouteOrMock(EApiRoutes.UPSERT_TABS), data);
  }, {});

  return {
    getTabs,
    upsertTabs
  };
}
